import { render } from "./TandartsBerlicum.vue?vue&type=template&id=6f5400a6&scoped=true"
import script from "./TandartsBerlicum.vue?vue&type=script&lang=js"
export * from "./TandartsBerlicum.vue?vue&type=script&lang=js"

import "./TandartsBerlicum.vue?vue&type=style&index=0&id=6f5400a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5400a6"]])

export default __exports__